import { withManagedProps } from "@made-people/managed-props";
import { useLink } from "@made-people/grease-link";

type ProductListTextCardTheme = "yellow" | "black" | "white";

type ProductListTextCardProps = {
  label?: string;
  heading?: string;
  description?: string;
  linkText?: string;
  link?: { cached_url?: string; url?: string; gearsUrl?: string };
  theme?: string;
};

const themeClasses: Record<ProductListTextCardTheme, string> = {
  yellow: "bg-yellow-100 text-black",
  black: "bg-black text-white",
  white: "bg-white text-black",
};

const toTheme = (theme?: string): ProductListTextCardTheme =>
  theme === "black" || theme === "white" ? theme : "yellow";

export const ProductListTextCard = withManagedProps(
  "ProductListTextCard",
  ({
    label,
    heading,
    description,
    linkText,
    link,
    theme,
  }: ProductListTextCardProps) => {
    const Link = useLink();
    const href = link?.gearsUrl || link?.cached_url || link?.url;

    const children = (
      <div
        className={`flex h-full w-full flex-col justify-between gap-8 rounded-lg px-4 py-6 lg:p-6 ${themeClasses[toTheme(theme)]}`}
      >
        <div className="flex flex-col gap-4">
          {label && <p className="text-label-sm uppercase">{label}</p>}
          {heading && (
            <p className="text-heading-md lg:text-heading-lg">{heading}</p>
          )}
          {description && <p className="text-body-sm">{description}</p>}
        </div>
        {linkText && (
          <span className="relative pl-3 text-label-sm uppercase before:absolute before:left-0 before:top-1/2 before:h-[5px] before:w-[5px] before:-translate-y-1/2 before:bg-current before:content-['']">
            {linkText}
          </span>
        )}
      </div>
    );

    if (href) {
      return (
        <Link
          className="block w-full self-start !h-auto lg:!h-[var(--plp-banner-height)]"
          href={href}
        >
          {children}
        </Link>
      );
    }

    return (
      <div className="w-full self-start !h-auto lg:!h-[var(--plp-banner-height)]">
        {children}
      </div>
    );
  },
);
